import { useCallback, useSyncExternalStore } from "react";
import { useCopySelectionContext } from "../context/CopySelectionContext";

export const useCellCopySelected = (
  rowIndex: number,
  columnId: string,
): boolean => {
  const { store } = useCopySelectionContext();

  const getSnapshot = useCallback(
    () => store.isCellSelected(rowIndex, columnId),
    [store, rowIndex, columnId],
  );

  return useSyncExternalStore(store.subscribe, getSnapshot);
};
